const carTheftWidget = (function () {
	let calc,
		form,
		claimResult,
		restartButton,
		bannerStep,
		bannerText,
		makeDropdown,
		modelDropdown,
		variantDropdown,
		modelDropdownField,
		variantDropdownField,
		claimResultText,
		claimResultValue,
		continueButton,
		totalBannerSteps;

	const resultText = document.getElementById('cft-cms'),
		bannerStep1Text = resultText.getAttribute('data-banner-step-1-text'),
		bannerStep2Text = resultText.getAttribute('data-banner-step-2-text'),
		selectMakeText = resultText.getAttribute('data-dropdown-select-make'),
		selectModelText = resultText.getAttribute('data-dropdown-select-model'),
		selectVariantText = resultText.getAttribute('data-dropdown-select-variant'),
		resultTestBasedOn = resultText.getAttribute('data-based-on'),
		veryHighText = resultText.getAttribute('data-value-vh-wording'),
		veryHighValue = parseInt(resultText.getAttribute('data-value-vh-value'), 10),
		highText = resultText.getAttribute('data-value-h-wording'),
		highValue = parseInt(resultText.getAttribute('data-value-h-value'), 10),
		mediumText = resultText.getAttribute('data-value-m-wording'),
		mediumValue = parseInt(resultText.getAttribute('data-value-m-value'), 10),
		smallText = resultText.getAttribute('data-value-s-wording'),
		smallValue = parseInt(resultText.getAttribute('data-value-s-value'), 10),
		verySmallText = resultText.getAttribute('data-value-vs-wording'),
		verySmallValue = parseInt(resultText.getAttribute('data-value-vs-value'), 10);

	async function init() {
		const data = await fetch(document.getElementById('cft-json').getAttribute('data-json-path'));
		const jsonData = await data.json();
		jsonData.sort((a, b) => sortByString(a.make, b.make));

		calc = document.getElementById('cnfsd-cft-widget');
		form = document.getElementById('cnfsd_cft-form');
		claimResult = document.getElementById('cnfsd_cft-result');
		bannerStep = calc.querySelector('.banner-current-progress');
		bannerText = calc.querySelector('.banner-current-text');
		makeDropdown = document.getElementById('cnfsd_cft-make');
		modelDropdown = document.getElementById('cnfsd_cft-model');
		variantDropdown = document.getElementById('cnfsd_cft-variant');
		modelDropdownField = document.getElementById('cnfsd_cft-model-field');
		variantDropdownField = document.getElementById('cnfsd_cft-variant-field');
		claimResultText = document.getElementById('cnfsd_cft-resultText');
		claimResultValue = document.getElementById('cnfsd_cft-resultValue');
		continueButton = document.getElementById('cnfsd_cft-continue');
		restartButton = calc.querySelector('a.arrow-link--back');
		totalBannerSteps = 2;

		function calculateBannerProgress() {
			const progress = document.querySelector('.banner__progress-bar__bar'),
				//CALC WIDTH OF EACH STEP IN THE PROCESS
				stepWidth = `${(100 / totalBannerSteps) * parseInt(bannerStep.innerHTML)}%`;
			progress.style.width = stepWidth;
		}

		calculateBannerProgress();

		function restartCalc() {
			makeDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectMakeText}</option>`;
			modelDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectModelText}</option>`;
			variantDropdown.innerHTML = `<option selected="selected" value="">${selectVariantText}</option>`;
			modelDropdownField.classList.add('display-none');
			variantDropdownField.classList.add('display-none');
			continueButton.classList.add('display-none');
			swapUi();
			bannerStep.innerHTML = 1;
			bannerText.innerHTML = bannerStep1Text;
			calculateBannerProgress();
			populateMakeDropdown();
		}

		function populateMakeDropdown() {
			jsonData.forEach(item => {
				const option = document.createElement('option');
				option.value = item.make;
				option.text = item.make;
				makeDropdown.appendChild(option);
			});

			// Add event listener to populate the models when a make is selected
			makeDropdown.addEventListener('change', function () {
				populateModelDropdown(this.value);
			});
		}

		function populateModelDropdown(selectedMake) {
			// Clear the current options
			modelDropdown.innerHTML = `<option selected="selected" disabled="disabled" value="">${selectModelText}</option>`;
			variantDropdown.innerHTML = `<option selected="selected" value="">${selectVariantText}</option>`;
			variantDropdownField.classList.add('display-none');

			// Clear the current options
			// modelDropdown.innerHTML = '<option value="">Select Model</option>';

			// Find the selected make's models and populate the dropdown
			const selectedMakeData = jsonData.find(item => item.make === selectedMake);
			if (selectedMakeData) {
				selectedMakeData.model.sort((a, b) => sortByString(a.name, b.name));

				selectedMakeData.model.forEach(modelItem => {
					const option = document.createElement('option');
					option.value = modelItem.name;
					option.text = modelItem.name;
					modelDropdown.appendChild(option);
				});
				modelDropdownField.classList.remove('display-none');
				modelDropdown.addEventListener('change', function () {
					populateVariantDropdown(selectedMake, this.value);
					continueButton.classList.remove('display-none');
				});
			} else {
				modelDropdownField.classList.add('display-none');
				variantDropdownField.classList.add('display-none');
				continueButton.classList.add('display-none');
			}
		}

		function populateVariantDropdown(selectedMake, selectedModel) {
			// Clear the current options
			variantDropdown.innerHTML = `<option selected="selected" value="">${selectVariantText}</option>`;

			// Find the selected make and model's variants and populate the dropdown
			const selectedMakeData = jsonData.find(item => item.make === selectedMake);
			const selectedModelData = selectedMakeData.model.find(item => item.name === selectedModel);

			if (selectedModelData && selectedModelData.variant && selectedModelData.variant.length > 0) {
				selectedModelData.variant.sort((a, b) => sortByString(a.name, b.name));

				selectedModelData.variant.forEach(variantItem => {
					const option = document.createElement('option');
					option.value = variantItem.name;
					option.text = variantItem.name;
					variantDropdown.appendChild(option);
				});
				// Remove the 'hidden' class to display the variant dropdown
				variantDropdownField.classList.remove('display-none');
			} else {
				// If no model is selected, hide the variant dropdown
				variantDropdownField.classList.add('display-none');
			}
		}

		// Show the claim number when continue button is clicked
		function showClaimNumber() {
			const selectedMake = makeDropdown.value;
			const selectedModel = modelDropdown.value;
			const selectedVariant = variantDropdown.value;
			let resultWording = '';

			// Find the selected make and model
			const selectedMakeData = jsonData.find(item => item.make === selectedMake);
			const selectedModelData = selectedMakeData.model.find(item => item.name === selectedModel);

			let claimNumber = selectedModelData.claims;

			// If a variant is selected, find the claim number for the variant
			if (selectedVariant) {
				const selectedVariantData = selectedModelData.variant.find(variant => variant.name === selectedVariant);
				claimNumber = selectedVariantData ? selectedVariantData.claims : claimNumber;
			}

			if (claimNumber <= verySmallValue) {
				resultWording = verySmallText;
			} else if (claimNumber <= smallValue) {
				resultWording = smallText;
			} else if (claimNumber <= mediumValue) {
				resultWording = mediumText;
			} else if (claimNumber <= highValue) {
				resultWording = highText;
			} else if (claimNumber >= veryHighValue) {
				resultWording = veryHighText;
			}

			// Display the claim text and number
			claimResultText.innerHTML = resultTestBasedOn.replace('{x}', claimNumber);
			claimResultValue.textContent = `${resultWording}`;
			claimResult.classList.remove('display-none');
			form.classList.add('display-none');
			bannerStep.innerHTML = 2;
			bannerText.innerHTML = bannerStep2Text;
			calculateBannerProgress();
		}

		function swapUi() {
			claimResult.classList.toggle('display-none');
			form.classList.toggle('display-none');
		}

		populateMakeDropdown();

		continueButton.addEventListener('click', function (e) {
			e.preventDefault();
			showClaimNumber();
		});

		restartButton.addEventListener('click', e => {
			e.preventDefault();
			restartCalc();
		});
	}

	function sortByString(a, b) {
		if (a < b) {
			return -1;
		}
		if (a > b) {
			return 1;
		}
		return 0;
	}

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', function () {
	carTheftWidget.init();
});
